import { useCurrentTenantQuery } from '@/modules/companies/queries/useCurrentTenantQuery';
import { DocumentMetadata } from '@/modules/layouts/components/DocumentMetadata';
import { AboutCompany } from '@/modules/signup-flow/components/AboutCompany';
import { CompanyGoals } from '@/modules/signup-flow/components/CompanyGoals';
import { SlackIntegration } from '@/modules/signup-flow/components/slackIntegration/SlackIntegration';
import { Summary } from '@/modules/signup-flow/components/summary/Summary';
import {
  getSignupFlowStep,
  signupFlowStep,
} from '@/modules/signup-flow/signupFlowSteps';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

const stepComponents = {
  [signupFlowStep.aboutCompany]: AboutCompany,
  [signupFlowStep.companyGoals]: CompanyGoals,
  [signupFlowStep.slack]: SlackIntegration,
  [signupFlowStep.summary]: Summary,
} as const;

export const SignupFlowRouter = () => {
  const currentTenantQuery = useCurrentTenantQuery();
  const persistedStep = currentTenantQuery.data?.onboarding?.step ?? 1;
  const currentStep = getSignupFlowStep(persistedStep);

  if (currentTenantQuery.isPending) {
    return (
      <div
        className="flex flex-col gap-3"
        aria-busy="true"
        aria-label="Loading your setup"
      >
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-8 w-3/4" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    );
  }

  const StepComponent =
    stepComponents[currentStep as keyof typeof stepComponents];

  if (!StepComponent) {
    return (
      <p className="text-muted-foreground text-[13px]">
        We couldn’t find where you left off. Please log out and back in, or
        contact support.
      </p>
    );
  }

  return (
    <>
      <DocumentMetadata title="Get started" />
      <StepComponent />
    </>
  );
};
